export default function Config(dataset, color) {
  const data = dataset.source.map((m, index) => (
    {
      name: m[0],
      value: m[1] ? m[1] : 0,
      textStyle: {
        normal: {
          color: color[index % color.length],
          fontWeight: 700,
        },
      },
    }
  ))

  const config = {
    series: [{
      type: 'wordCloud',
      left: 'center',
      top: 'center',
      width: '100%',
      height: '100%',
      sizeRange: [12, 40],
      rotationRange: [0, 0],
      rotationStep: 45,
      gridSize: 10,
      drawOutOfBound: false,
      data
    }]
  }
  return config
}
